import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Modal } from '../ui';
import { Button } from '../ui/Button';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonClass?: string;
  isDestructive?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonClass,
  isDestructive = false,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
            isDestructive ? 'bg-red-100' : 'bg-blue-100'
          }`}>
            <AlertCircle className={`w-5 h-5 ${isDestructive ? 'text-red-600' : 'text-blue-600'}`} />
          </div>
          <span>{title}</span>
        </div>
      }
      size="md"
      footer={
        <div className="flex items-center justify-end gap-3">
          <Button
            onClick={onClose}
            variant="neutral"
            padding="px-4 py-2"
            fontSize="text-sm"
            className="font-medium"
          >
            {cancelText}
          </Button>
          <Button
            onClick={handleConfirm}
            variant={isDestructive ? "danger" : "primary"}
            padding="px-4 py-2"
            fontSize="text-sm"
            className={`font-medium shadow-sm ${confirmButtonClass || ''}`}
          >
            {confirmText}
          </Button>
        </div>
      }
    >
      <p className="text-[15px] text-[rgba(47,43,61,0.7)] leading-[22px]">
        {message}
      </p>
    </Modal>
  );
};

export default ConfirmationModal;
